const CouponQueryKey = {
  COUPON: 'COUPON',
  COUPON_DOWNLOAD: 'COUPON_DOWNLOAD',
};

export default CouponQueryKey;
